import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function ArrowRightIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.47144 7.45143C2.2052 7.48809 2 7.71969 2 7.99993C2 8.30564 2.24421 8.55347 2.54545 8.55347L12.1333 8.55347L8.6698 12.0542L8.61686 12.1162C8.45797 12.3326 8.47495 12.6401 8.6682 12.8371C8.88077 13.0537 9.22613 13.0544 9.43959 12.8387L13.8318 8.3997C13.858 8.37427 13.8816 8.34622 13.9024 8.31597C14.0511 8.0998 14.0301 7.79995 13.8396 7.60737L9.43955 3.16129L9.37826 3.10782C9.16439 2.9475 8.8614 2.96603 8.66817 3.16297C8.45561 3.37961 8.45636 3.7301 8.66983 3.9458L12.1342 7.44638L2.54545 7.44638L2.47144 7.45143Z"
      />
    </SvgIcon>
  );
}
